import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import styles from './Footer.module.scss';

interface IModalFooterProps {
  children: React.ReactNode;
  className?: string;
}

const ModalFooter: FC<IModalFooterProps> = ({ children, className }) => {
  return (
    <footer className={classes([styles.footer, className])}>{children}</footer>
  );
};

export default observer(ModalFooter);
